import { ELITE_QUIZ_TYPE } from '../utils/constants';
import convertObjectToFormData from '../utils/convertObjectToFormData';
import { DeleteApi, GetApi, PostApi, PutApi } from './api';

// Example: POST new category
export const createCategory = async (formData) => {
  try {
    // convert formData as actual form data

    const formDataToSend = new FormData();
    formDataToSend.append('language', formData.language);
    formDataToSend.append('categoryName', formData.categoryName);
    formDataToSend.append('image', formData.image[0]); // Assuming image is a FileList and you want the first file
    formDataToSend.append('slug', formData.slug);
    formDataToSend.append('quizType', formData.quizType);
    formDataToSend.append('isPremium', formData.isPremium);
    if (formData.coins) {
      formDataToSend.append('coins', formData.coins);
    }
    const response = await PostApi(
      'admin/v1/quize-game/create-category',
      formDataToSend,
      true,
      true
    );

    if (!response) {
      throw new Error('Failed to create category');
    }

    return response.data; // Return the created category or success response
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

export const GetMainCategories = async (params) => {
  let queryParams = '';

  if (params) {
    const queryArray = [];
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null) {
        queryArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    }
    if (queryArray.length > 0) {
      queryParams = `?${queryArray.join('&')}`;
    }
  }

  const endpoint = `admin/v1/quize-game/all-category${queryParams}`;
  const response = await GetApi(endpoint); // Adjust the endpoint
  return response.data;
};

export const updateCategoryOrder = async (orderData) => {
  try {
    const response = await PutApi('admin/v1/quize-game/category-order', orderData, true);

    if (!response) {
      throw new Error('Failed to update category order');
    }

    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

// Update category
export const updateCategory = async (id, formData) => {
  try {
    const formDataToSend = new FormData();
    formDataToSend.append('language', formData.language);
    formDataToSend.append('categoryName', formData.categoryName);
    if (formData.image && formData.image[0]) {
      formDataToSend.append('image', formData.image[0]);
    }
    formDataToSend.append('slug', formData.slug);
    formDataToSend.append('quizType', formData.quizType);
    formDataToSend.append('isPremium', formData.isPremium);
    if (formData.coins) {
      formDataToSend.append('coins', formData.coins);
    }

    const response = await PutApi(`admin/v1/quize-game/category/${id}`, formDataToSend, true, true);

    if (!response) {
      throw new Error('Failed to update category');
    }

    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

export const updateContest = async (id, formData) => {
  console.log('formData before appending:', formData);
  try {
    const formDataToSend = new FormData();
    formDataToSend.append('language', formData.language);
    formDataToSend.append('name', formData.name);
    if (formData.image && formData.image[0]) {
      formDataToSend.append('image', formData.image[0]);
    }
    formDataToSend.append('entryFeePoints', formData.entryFeePoints);
    formDataToSend.append('description', formData.description);
    formDataToSend.append('distributePrize', formData.distributePrize);
    formDataToSend.append('startDate', formData.startDate);
    formDataToSend.append('endDate', formData.endDate);
    if (formData.prizeDistribution && Array.isArray(formData.prizeDistribution)) {
      formDataToSend.append('prizeDistribution', JSON.stringify(formData.prizeDistribution));
    } else if (formData.prizeDistribution) {
      formDataToSend.append('prizeDistribution', formData.prizeDistribution);
    }
    // if (formData.prizeDistribution) {
    //   formDataToSend.append('prizeDistribution', formData.prizeDistribution);
    // }
    console.log('formData before appending:', formData);
    const response = await PutApi(`admin/v1/quize-game/contest/${id}`, formDataToSend, true, true);

    if (!response) {
      throw new Error('Failed to update contest');
    }

    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

export const updateContestStatus = async (id, isActive) => {
  console.log('Sending status:', { isActive: Boolean(isActive) });
  try {
    const response = await PutApi(
      `admin/v1/quize-game/contest/${id}`,
      { isActive: Boolean(isActive) }, // 👈 ensures true/false
      true
    );

    if (!response) throw new Error('Failed to update contest status');
    return response.data;
  } catch (error) {
    console.error('API error in updateContestStatus:', error);
    throw error;
  }
};

//update Subcategory
export const updateSubCategory = async (id, formData) => {
  console.log('Updating subcategory with ID:', id, 'and data:', formData);
  try {
    const formDataToSend = new FormData();
    formDataToSend.append('language', formData.language);
    formDataToSend.append('categoryName', formData.categoryName);
    if (formData.image && formData.image[0]) {
      formDataToSend.append('image', formData.image[0]);
    }

    formDataToSend.append('quizType', formData.quizType);
    if (formData.coins) {
      formDataToSend.append('coins', formData.coins);
    }

    const response = await PutApi(
      `admin/v1/quize-game/subcategories/${id}`,
      formDataToSend,
      true,
      true
    );

    if (!response) {
      throw new Error('Failed to update category');
    }

    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

// Delete category
export const deleteCategory = async (id) => {
  try {
    const response = await DeleteApi(`admin/v1/quize-game/category/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response) {
      throw new Error('Failed to update subcategory order');
    }

    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

//Delete subcategory
export const deleteSubCategory = async (id) => {
  try {
    const response = await DeleteApi(`admin/v1/quize-game/subcategories/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response) {
      throw new Error('Failed to update subcategory order');
    }

    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};
export const deleteManageFunNLearn = async (id) => {
  try {
    const response = await DeleteApi(`admin/v1/quize-game/fun-and-learn/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response) {
      throw new Error('Failed to update subcategory order');
    }

    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

export const deleteExamModule = async (id) => {
  try {
    const response = await DeleteApi(`admin/v1/quize-game/exam/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response) {
      throw new Error('Failed to delete exam module');
    }

    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

//Delete question
export const deleteQuestion = async (id) => {
  try {
    const response = await DeleteApi(`admin/v1/quize-game/question/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response) {
      throw new Error('Failed to delete question');
    }

    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

//Delete contest
export const deleteContest = async (id) => {
  try {
    const response = await DeleteApi(`admin/v1/quize-game/contest/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response) {
      throw new Error('Failed to delete contest');
    }

    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

export const updateSubcategoryOrder = async (orderData) => {
  try {
    const response = await PutApi('admin/v1/quize-game/subcategories-order', orderData, true);

    if (!response) {
      throw new Error('Failed to update subcategory order');
    }

    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

export const changeContestStatus = async (contestId, newStatus) => {
  try {
    const response = await PutApi('admin/v1/quize-game/contest', { contestId, newStatus }, true);

    if (!response) {
      throw new Error('Failed to update contest status');
    }

    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

export const createSubCategory = async (formData) => {
  try {
    // convert formData as actual form data

    const formDataToSend = new FormData();
    formDataToSend.append('language', formData.language);
    formDataToSend.append('categoryId', formData.categoryId);
    formDataToSend.append('categoryName', formData.categoryName);
    formDataToSend.append('image', formData.image[0]); // Assuming image is a FileList and you want the first file
    formDataToSend.append('slug', formData.slug);
    formDataToSend.append('quizType', formData.quizType);

    const response = await PostApi(
      'admin/v1/quize-game/create-sub-category',
      formDataToSend,
      true,
      true
    );

    if (!response) {
      throw new Error('Failed to create Subcategory');
    }

    return response.data; // Return the created category or success response
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};
export const GetSubCategories = async (params) => {
  let queryParams = '';

  if (params) {
    const queryArray = [];
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null) {
        queryArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    }
    if (queryArray.length > 0) {
      queryParams = `?${queryArray.join('&')}`;
    }
  }

  const endpoint = `admin/v1/quize-game/all-sub-category${queryParams}`;
  const response = await GetApi(endpoint); // Adjust the endpoint
  console.log('Fetched sub categories:', response.data);
  return response.data;
};
export const importQuestions = async (file, quizType) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('quizType', quizType);
  const response = await PostApi('admin/v1/quize-game/import-questions', formData, true, true);
  console.log('Import response:', response);
  if (!response) {
    throw new Error('Failed to create category');
  }

  return response.data;
};

export const createNewContest = async (formData) => {
  try {
    const formDataToSend = new FormData();
    formDataToSend.append('language', formData.language);
    formDataToSend.append('name', formData.name);
    formDataToSend.append('image', formData.image[0]);
    formDataToSend.append('entryFeePoints', formData.entryFeePoints);
    formDataToSend.append('distributePrize', formData.distributePrize);
    formDataToSend.append('description', formData.description);
    formDataToSend.append('startDate', formData.startDate);
    formDataToSend.append('endDate', formData.endDate);
    formDataToSend.append('prizeDistribution', JSON.stringify(formData.prizeDistribution));
    const response = await PostApi('admin/v1/quize-game/contest', formDataToSend, true, true);
    console.log('Contest creation response:', response);
    if (!response) {
      throw new Error('Failed to create contest');
    }

    return response.data; // Return the created contest or success response
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

export const getContests = async (params) => {
  let queryParams = '';

  if (params) {
    const queryArray = [];
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null) {
        queryArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    }
    if (queryArray.length > 0) {
      queryParams = `?${queryArray.join('&')}`;
    }
  }

  const endpoint = `admin/v1/quize-game/contests${queryParams}`;
  const response = await GetApi(endpoint); // Adjust the endpoint
  console.log('Fetched contests:', response.data);
  return response.data;
};

export const createNewFunNLearn = async (formData) => {
  try {
    const formDataToSend = new FormData();
    formDataToSend.append('contentType', formData.contentType);
    formDataToSend.append('language', formData.language);
    formDataToSend.append('mainCategory', formData.mainCategory);
    formDataToSend.append('subCategory', formData.subCategory);
    formDataToSend.append('title', formData.title);
    if (formData.youtubeId && formData.youtubeId.trim() !== '') {
      formDataToSend.append('youtubeId', formData.youtubeId);
    }
    formDataToSend.append('details', formData.details);
    if (formData.contentType === 'pdf') {
      formDataToSend.append('file', formData.file[0]); // Assuming file is a FileList and you want the first file
    }
    const response = await PostApi('admin/v1/quize-game/fun-and-learn', formDataToSend, true, true);
    console.log('Fun N Learn creation response:', response);
    if (!response) {
      throw new Error('Failed to create Fun N Learn');
    }

    return response.data; // Return the created Fun N Learn or success response
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};
export const updateFunNLearn = async (formData) => {
  try {
    const formDataToSend = new FormData();
    formDataToSend.append('contentType', formData.contentType);
    formDataToSend.append('language', formData.language);
    formDataToSend.append('mainCategory', formData.mainCategory);
    formDataToSend.append('subCategory', formData.subCategory);
    formDataToSend.append('title', formData.title);
    formDataToSend.append('youtubeId', formData.youtubeId);
    formDataToSend.append('details', formData.details);
    if (formData.contentType === 'pdf') {
      formDataToSend.append('file', formData.file[0]); // Assuming file is a FileList and you want the first file
    }
    const response = await PutApi(
      'admin/v1/quize-game/fun-and-learn/' + formData._id,
      formDataToSend,
      true,
      true
    );
    console.log('Fun N Learn creation response:', response);
    if (!response) {
      throw new Error('Failed to create Fun N Learn');
    }

    return response.data; // Return the created Fun N Learn or success response
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};
export const GetFunNLearnList = async (params) => {
  let queryParams = '';

  if (params) {
    const queryArray = [];
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null) {
        queryArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    }
    if (queryArray.length > 0) {
      queryParams = `?${queryArray.join('&')}`;
    }
  }

  const endpoint = `admin/v1/quize-game/fun-and-learn${queryParams}`;
  const response = await GetApi(endpoint); // Adjust the endpoint
  console.log('Fetched Fun N Learn List:', response.data);
  return response.data;
};
export const createQuestion = async (formData) => {
  try {
    const formDataToSend = new FormData();
    formDataToSend.append('questionType', formData.questionType);
    formDataToSend.append('language', formData.language);
    if (formData.level) {
      formDataToSend.append('level', formData.level);
    }
    if (formData.mainCategory) {
      formDataToSend.append('categoryId', formData.mainCategory);
    }
    if (formData.mark) {
      formDataToSend.append('mark', formData.mark);
    }
    if (formData.note) {
      formDataToSend.append('note', formData.note);
    }
    if (formData.subCategory) {
      formDataToSend.append('subCategoryId', formData.subCategory);
    }
    formDataToSend.append('question', formData.question);
    if (formData.image && formData.image.length > 0) {
      formDataToSend.append('image', formData.image[0]);
    }
    formDataToSend.append('quizType', formData.quizType);
    if (formData.options && Array.isArray(formData.options)) {
      formDataToSend.append('options', JSON.stringify(formData.options));
    }
    if (formData.audioType) {
      formDataToSend.append('audioType', formData.audioType);
      if (formData.audioType === 'audioUpload') {
        if (formData.audioFile && formData.audioFile.length > 0) {
          formDataToSend.append('audio', formData.audioFile[0]);
        }
      } else {
        formDataToSend.append('audioLink', formData.audioLink);
      }
    }
    if (formData.quizType == ELITE_QUIZ_TYPE.MULTI_MATCH) {
      formDataToSend.append('correctAnswer', JSON.stringify(formData.correctAnswer));
      formDataToSend.append('answerType', formData.answerType);
    } else {
      formDataToSend.append('correctAnswer', formData.correctAnswer);
    }
    if (formData.funLearnId) {
      formDataToSend.append('funLearnId', formData.funLearnId);
    }
    if (formData.examId) {
      formDataToSend.append('examId', formData.examId);
    }
    if (formData.contestId) {
      formDataToSend.append('contestId', formData.contestId);
    }
    const response = await PostApi('admin/v1/quize-game/question', formDataToSend, true, true);

    if (!response) {
      throw new Error('Failed to create Question');
    }
    return response.data; // Return the created Question or success response
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};
export const updateQuestion = async (formData, id) => {
  try {
    const formDataToSend = new FormData();
    formDataToSend.append('questionType', formData.questionType);
    formDataToSend.append('language', formData.language);
    formDataToSend.append('level', formData.level);
    if (formData.mainCategory) {
      formDataToSend.append('categoryId', formData.mainCategory);
    }
    if (formData.subCategory) {
      formDataToSend.append('subCategoryId', formData.subCategory);
    }
    formDataToSend.append('question', formData.question);
    if (formData.image && formData.image.length > 0) {
      formDataToSend.append('image', formData.image[0]);
    }
    formDataToSend.append('quizType', formData.quizType);
    formDataToSend.append('note', formData.note);
    if (formData.options && Array.isArray(formData.options)) {
      formDataToSend.append('options', JSON.stringify(formData.options));
    }
    if (formData.audioType) {
      formDataToSend.append('audioType', formData.audioType);
      if (formData.audioType === 'audioUpload') {
        if (formData.audioFile && formData.audioFile.length > 0) {
          formDataToSend.append('audio', formData.audioFile[0]);
        }
      } else {
        formDataToSend.append('audioLink', formData.audioLink);
      }
    }
    if (formData.quizType == ELITE_QUIZ_TYPE.MULTI_MATCH) {
      formDataToSend.append('correctAnswer', JSON.stringify(formData.correctAnswer));
      formDataToSend.append('answerType', formData.answerType);
    } else {
      formDataToSend.append('correctAnswer', formData.correctAnswer);
    }
    if (formData.funLearnId) {
      formDataToSend.append('funLearnId', formData.funLearnId);
    }
    if (formData.examId) {
      formDataToSend.append('examId', formData.examId);
    }

    const response = await PutApi('admin/v1/quize-game/question/' + id, formDataToSend, true, true);

    if (!response) {
      throw new Error('Failed to create Question');
    }
    return response.data; // Return the created Question or success response
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};
export const getQuestionsByQuizType = async (quizType, params) => {
  try {
    let queryParams = '';

    if (params) {
      const queryArray = [];
      for (const [key, value] of Object.entries(params)) {
        if (value !== undefined && value !== null) {
          queryArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
      }
      if (queryArray.length > 0) {
        queryParams = `?${queryArray.join('&')}`;
      }
    }

    const endpoint = `admin/v1/quize-game/questions/${quizType}${queryParams}`;
    const response = await GetApi(endpoint);
    console.log('Fetched questions:', response.data);
    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

//Post Api of Exam Module
export const PostExamModule = async (data) => {
  try {
    const response = await PostApi('admin/v1/quize-game/exam', data, true, true);

    if (!response) {
      throw new Error('Failed to create exam');
    }

    return response.data; // Return the created exam or success response
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};
//Post Api of Exam Module
export const PutExamModule = async (id, data) => {
  try {
    const response = await PutApi('admin/v1/quize-game/exam/' + id, data, true, true);

    if (!response) {
      throw new Error('Failed to create exam');
    }

    return response.data; // Return the created category or success response
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};

export const GetExamModule = async (params) => {
  let queryParams = '';

  if (params) {
    const queryArray = [];
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null) {
        queryArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    }
    if (queryArray.length > 0) {
      queryParams = `?${queryArray.join('&')}`;
    }
  }

  const endpoint = `admin/v1/quize-game/exams${queryParams}`;
  const response = await GetApi(endpoint); // Adjust the endpoint
  console.log('Fetched exams:', response.data);
  return response.data;
};

export const getSettings = async () => {
  try {
    const response = await GetApi('admin/v1/quize-game/settings');
    console.log('Fetched settings:', response.data);
    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};
export const updateSettings = async (data) => {
  try {
    const response = await PutApi('admin/v1/quize-game/settings', data, true);
    console.log('Updated settings:', response.data);
    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};
export const getAllLeaderBoard = async (params) => {
  try {
    let queryParams = '';

    if (params) {
      const queryArray = [];
      for (const [key, value] of Object.entries(params)) {
        if (value !== undefined && value !== null) {
          queryArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
      }
      if (queryArray.length > 0) {
        queryParams = `?${queryArray.join('&')}`;
      }
    }
    const response = await GetApi('admin/v1/quize-game/leaderboard_all' + queryParams);
    console.log('Fetched settings:', response.data);
    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};
export const getMonthlyLeaderBoard = async (params) => {
  let queryParams = '';

  if (params) {
    const queryArray = [];
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null) {
        queryArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    }
    if (queryArray.length > 0) {
      queryParams = `?${queryArray.join('&')}`;
    }
  }
  try {
    const response = await GetApi('admin/v1/quize-game/leaderboard_monthly' + queryParams);
    console.log('Fetched settings:', response.data);
    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};
export const getDailyLeaderBoard = async (params) => {
  let queryParams = '';

  if (params) {
    const queryArray = [];
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null) {
        queryArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    }
    if (queryArray.length > 0) {
      queryParams = `?${queryArray.join('&')}`;
    }
  }
  try {
    const response = await GetApi('admin/v1/quize-game/leaderboard_daily' + queryParams);
    console.log('Fetched settings:', response.data);
    return response.data;
  } catch (error) {
    console.error('API error:', error);
    throw error;
  }
};
